export const applicationStatuses = {
  STARTED: "STARTED",
  REVIEW: "REVIEW",
  RETURNED: "RETURNED",
  VERIFIED: "VERIFIED",
  INVALIDATED: "INVALIDATED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  COMPLETED: "COMPLETED",
};

export const internshipTypes = {
  IT: "it",
  GAP: "gap",
  SIWES: "siwes",
};
